export default __webpack_public_path__ + "static/1021-d533e234b5185f2583ddae9fe54eee5b.gif";